import React from 'react';
import styled from 'astroturf/react';
import { Popover, PopoverMode, PopoverProps } from './Popover';
import _MenuContainer from "Menu-MenuContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Menu.tsx?styleId=MenuContainer";
import _ScrollItems from "Menu-ScrollItems.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/design_system/Menu.tsx?styleId=ScrollItems";


const MenuContainer = /*#__PURE__*/styled("div", null, {
  displayName: "MenuContainer",
  styles: _MenuContainer
});

// This container
const ScrollItems = /*#__PURE__*/styled("div", null, {
  displayName: "ScrollItems",
  styles: _ScrollItems
});

/**
 * A basic menu component with Academia styling. This component uses
 * {@link Popover} as its parent, adding some nicer styling.
 *
 * ## Basic Usage
 *
 * @example
 *
 * ```tsx
 * import { Menu } from 'js/design_system/Menu';
 * import { PopoverMode } from 'js/design_system/Popover';
 *
 * <Menu
 *   mode={PopoverMode.Click}
 *   placement='bottom-start'
 *   offset={4}
 *   render={() => <p>I'm the popover content!</p>}
 * >
 *   <p>Click me to activate!</p>
 * </Menu>
 * ```
 */
export const Menu: React.FC<PopoverProps> = ({
  mode = PopoverMode.Click,
  closeOnClick = true,
  popoverRef,
  render,
  children,
  ...props
}) => {
  return (
    <Popover
      mode={mode}
      closeOnClick={closeOnClick}
      render={() => {
        return (
          <MenuContainer ref={popoverRef}>
            <ScrollItems>{render()}</ScrollItems>
          </MenuContainer>
        );
      }}
      {...props}
    >
      {children}
    </Popover>
  );
};
